export default __webpack_public_path__ + "44ab4765a57c5e08e62d2097c2ce44bc.png";